//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObject.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../Annotations/Annotations.TextWithEditControlsBuilder.js";
import "../no/SelectObject.js";
let d=[[[0,"ForeshorteningSymbol",0,"Annotations.ForeshorteningSymbolBuilder",0],[1,"Inherit",0,"SelectDisplayableObject",0],[1,"Leader",0,"Annotations.LeaderBuilder",0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"Style",0,"Annotations.StyleBuilder",0],[1,"Text",0,"Annotations.TextWithEditControlsBuilder",0],[0,"TextAlignment",1,0],[0,"VerticalText",1,0]],[[["annotation","recordNumber"],"InheritProperties",{},2,0]],[]];
SPLM.Annotations.DraftingNoteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.DraftingNoteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.DraftingNoteBuilder.TextAlign = Object.freeze({
    "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom", "BelowbottomExtToMax" : "BelowbottomExtToMax", "BelowbottomExtToMaxUnderline" : "BelowbottomExtToMaxUnderline", "Belowbottom" : "Belowbottom", "BelowbottomUnderline" : "BelowbottomUnderline", "BelowTopExtToMax" : "BelowTopExtToMax", "BelowTopExtToMaxUnderline" : "BelowTopExtToMaxUnderline", "BelowTop" : "BelowTop", "BelowTopUnderline" : "BelowTopUnderline"});

SPLM.Annotations.DraftingNoteBuilder.ThicknessTypes = Object.freeze({
    "Medium" : "Medium", "Thick" : "Thick"});

export default SPLM;